import { SVGIconProps } from './types/types';

const Globe = ({ width = 24, height = 24 }: SVGIconProps) => (
  <svg
    focusable={false}
    height={height}
    viewBox='0 0 24 24'
    width={width}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='m12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17zm0 1.5c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10zm-7.256-14.43c.257-.42.55-.816.874-1.184 1.311.574 3.656 1.114 6.382 1.114s5.07-.54 6.382-1.114c.324.368.617.764.874 1.185-1.638.867-4.278 1.429-7.256 1.429s-5.618-.562-7.256-1.43zm12.242 5.18c-.036.965-.14 1.891-.303 2.76 1.004.239 1.879.552 2.573.92a8.53 8.53 0 0 1 -.874 1.184c-.528-.231-1.223-.457-2.042-.644-.863 3.006-2.483 5.03-4.34 5.03s-3.477-2.024-4.34-5.03c-.82.187-1.514.413-2.042.644a8.53 8.53 0 0 1 -.874-1.185c.694-.367 1.569-.68 2.573-.918a18.801 18.801 0 0 1 -.303-2.761h-4.014a.75.75 0 1 1 0-1.5h4.014c.192-5.173 2.35-9.25 4.986-9.25 2.635 0 4.794 4.077 4.986 9.25h4.014a.75.75 0 1 1 0 1.5zm-1.501 0h-6.97c.036.875.132 1.707.276 2.479a21.97 21.97 0 0 1 3.209-.229c1.13 0 2.212.081 3.209.229.144-.772.24-1.604.276-2.479zm0-1.5c-.18-4.43-1.922-7.75-3.485-7.75s-3.305 3.32-3.485 7.75zm-.627 5.45a20.505 20.505 0 0 0 -5.716 0c.685 2.312 1.811 3.8 2.858 3.8s2.173-1.488 2.858-3.8z' />
  </svg>
);

export default Globe;
